import React from 'react';
import '../../styles/contact-page.scss';

const WufooForm = require('react-wufoo-embed');

export class ContactPage extends React.Component {

  render() {
    return (
      <div className="pagecontent">
        <h2>Contact</h2>
        <p>For more information about me, or a copy of my full CV, please get in contact and I'll get back to you as soon as possible:</p>
        <WufooForm userName="davidcoe" formHash="z116jgv90r19dff" header="hide" autoResize={true} />
      </div>
    );
  }
}

export default ContactPage
